module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-report-horometer/master-report-horometer.component.scss
// module id = ./src/app/master/master-report-horometer/master-report-horometer.component.scss
// module chunks = main